import './index.css';
import 'react-simple-keyboard/build/css/index.css';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import { Root } from './Root';

Sentry.init({
  dsn: 'https://3632a0b1bf61811b3111343a48daae73@o4509051245428736.ingest.us.sentry.io/4509514037002240',
  enabled: process.env.SENTRY_ENABLED === 'true',
  release: process.env.SENTRY_RELEASE,
  environment: process.env.SENTRY_ENV,
  integrations: [
    Sentry.browserTracingIntegration({
      enableInp: true,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
    }),
    Sentry.browserProfilingIntegration(),
  ],
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^\//],
  profilesSampleRate: 1.0,
  replaysSessionSampleRate: 0.5,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.querySelector('#root')!).render(<Root />);
